<h2 mat-dialog-title id="facility-deletion-impact-title">
  {{ 'FacilityDeletionImpactDialog.Title' | translate }}
</h2>

<div mat-dialog-content id="facility-deletion-impact-description" class="dialog-content">
  <p class="user-count" aria-live="polite">
    {{ 'FacilityDeletionImpactDialog.UserCount' | translate:{ count: data.affectedUserCount } }}
  </p>
  <p class="reassignment-warning">
    {{ 'FacilityDeletionImpactDialog.ReassignmentWarning' | translate }}
  </p>

  <ul class="user-list" aria-label="{{ 'FacilityDeletionImpactDialog.UserListLabel' | translate }}">
    <li *ngFor="let user of data.users" class="user-row">
      <span class="user-name">{{ user.displayName || user.email || user.externalObjectId }}</span>
      <span *ngIf="user.displayName && user.email" class="user-email">{{ user.email }}</span>
      <span *ngIf="user.identityUnavailable" class="identity-unavailable">
        {{ 'FacilityDeletionImpactDialog.IdentityUnavailable' | translate }}
      </span>
      <span class="user-identifier">{{ user.externalObjectId }}</span>
    </li>
  </ul>

  <p class="confirmation-instruction">{{ 'FacilityDeletionImpactDialog.ConfirmInstruction' | translate }}</p>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'FacilityDeletionImpactDialog.ConfirmInputLabel' | translate }}</mat-label>
    <input matInput #userCount inputmode="numeric" autocomplete="off"
      [placeholder]="userCountFocused ? '' : ('FacilityDeletionImpactDialog.ConfirmInputLabel' | translate)"
      (focus)="userCountFocused = true" (blur)="userCountFocused = false"
      (input)="enteredUserCount = userCount.value">
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()" cdkFocusInitial>
    {{ 'FacilityDeletionImpactDialog.CancelButton' | translate }}
  </button>
  <button mat-flat-button color="warn" type="button" (click)="onConfirm()" [disabled]="!userCountMatches">
    {{ 'FacilityDeletionImpactDialog.ConfirmButton' | translate }}
  </button>
</div>
